import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { UiModal } from 'src/components/UI/modal/UiModal';
import { commonSlice } from 'src/store/commonPart/slice';
import styles from 'src/styles/common/expiredCampaigns.module.scss';
import { useTHelper } from 'src/utils/i18n';
import { ExpiredCampaignsResponseType } from 'src/models/Modals/expiredCampaigns';
import { deCommonCurrentPartnerSelector, expiredCampaignsModalSelector } from 'src/store/commonPart/selector';
import { ExpiredCampaignsItem } from 'src/components/Modals/ExpiredCampaigns/ExpiredCampaignsItem';

const Modal: FC<ExpiredCampaignsResponseType> = ({ CountExpiredSoonCampaign, Items }) => {
  const tHelper = useTHelper('modals.expiredCampaigns');

  const dispatch = useDispatch();

  const { CampaignTerminologySingular, CampaignTerminologyPlural } = useSelector(deCommonCurrentPartnerSelector);

  const handleClose = () => dispatch(commonSlice.actions.hideExpiredCampaignsModal());

  return (
    <UiModal
      onlySuccessBtn
      onHide={handleClose}
      modalClassName={styles.modal}
      successBtnText={tHelper('close')}
      header={
        CountExpiredSoonCampaign === 1
          ? tHelper('header1', { campaignSingularTerminology: CampaignTerminologySingular })
          : tHelper('header2', { campaignPluralTerminology: CampaignTerminologyPlural })
      }
    >
      <div className={styles.description}>{tHelper('description')}</div>
      <div className={styles.campaigns}>
        {Items.map((item) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <ExpiredCampaignsItem key={item.Url} {...item} />
        ))}
      </div>
    </UiModal>
  );
};

export const ExpiredCampaignsModal: FC = () => {
  const { isShow, ...rest } = useSelector(expiredCampaignsModalSelector);

  // eslint-disable-next-line react/jsx-props-no-spreading
  return isShow ? <Modal {...rest} /> : null;
};
